import * as Popper from "popper.js";
import * as React from 'react';
import { DateTimePicker } from "../datetime-picker/DateTimePicker";
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id                  : string;
    label               : string;
    value               : any;
    onChange            : any;
    className?          : string;
    error?              : string;
    disable?            : boolean;
    format?             : string;
    showInlineLabels?   : boolean;
    placeholder?        : string;
    onBlur?             : any;

    showTimezone?       : boolean;
    timezone?           : string;

    readOnly?           : boolean;
    highlightDates?     : Date[];

    maxDate?            : Date;
    minDate?            : Date;
    
    maxTime?            : Date;    
    minTime?            : Date;
    
    includeDates?       : Date[];
    excludeDates?       : Date[];
    
    includeTimes?       : Date[];
    excludeTimes?       : Date[];

    startDate?          : Date;
    endDate?            : Date;

    inline?             : boolean;
    withPortal?         : boolean;
    popperModifiers?    : Popper.Modifiers;
}

// #endregion

const DateTimeInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        value, 
        onChange, 
        disable,
        showInlineLabels,
        placeholder,
        onBlur,
        showTimezone,
        timezone
    } = props;

    return (
        <div className={'form-group datetime-input ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <DateTimePicker 
                dateValue={ value }
                classes="form-control"
                handleChange={ onChange }
                disable={ disable }
                showTimezone={ showTimezone }
                timezone={ timezone }
                placeholder={ placeholder }
                showLabels={ showInlineLabels }
                {...props} />
            <InputFeedback error={error} />
        </div>
    );
};

DateTimeInput.defaultProps = {
    className        : '',
    error            : '',
    disable          : false,
    format           : '',
    showInlineLabels : false,
    placeholder      : '',
    onBlur           : undefined
};

export { DateTimeInput };
